import { Component, OnInit, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CatalogService } from '@catalog/catalog.service';
import { DATA_PER_PAGE } from '@root/app.constant';

@Component({
  selector: 'app-fund-manager-images',
  templateUrl: './fund-manager-images.component.html',
  styleUrls: ['./fund-manager-images.component.scss'],
})
export class FundManagerImagesComponent implements OnInit {
  constructor(
    private toastr: ToastrService,
    private catalogService: CatalogService
  ) {}

  @Input() data: any[];

  pageSize: number = DATA_PER_PAGE;

  ngOnInit() {
    this.readAllFundManagers();
  }

  private readAllFundManagers() {
    this.catalogService.readAllFundmangers().subscribe(
      (response) => {
        this.data = response.data.list;
      },
      (error) => {}
    );
  }

  viewFile = (path) => {
    window.open(path, '_blank');
  };
}
